import type { BlogPost } from "./blog";

export const BLOG_EVENTS_PART3: BlogPost[] = [
  {
    "slug": "gde-zakazat-zal-den-rozhdeniya-peterburg",
    "title": "Где заказать зал на день рождения в Петербурге",
    "metaTitle": "Где заказать зал на день рождения Петербург 2026 | Паруса на крыше",
    "metaDescription": "Как и где заказать зал на день рождения в Санкт-Петербурге: советы по выбору, цены, вместимость.",
    "keywords": "заказать зал день рождения петербург, аренда зала день рождения спб, зал на день рождения петербург",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "Выбор зала для дня рождения — одно из самых важных организационных решений. От этого зависит атмосфера, логистика, комфорт гостей и итоговый бюджет вечера. Разберём, на что обратить внимание при поиске и бронировании.",
    "sections": [
      {
        "heading": "Типы залов для дня рождения",
        "body": "Банкетный зал в ресторане: самый удобный вариант — кухня, обслуживание и декор уже включены. Отдельная комната в кафе: подходит для небольших компаний (10–20 человек), демократичнее по цене. Приватная зона ресторана: открытое пространство с отделённым столом — хорошо для 8–15 гостей. Выкуп всего ресторана: актуально для большой компании (50+), обычно от 100 000 ₽.",
        "list": [
          "Банкетный зал: отдельное помещение, максимальная приватность",
          "Приватная зона: доступнее, подходит для 8–15 человек",
          "Выкуп ресторана: для больших компаний (50+ человек)",
          "Выездное мероприятие: ресторан едет к вам"
        ]
      },
      {
        "heading": "На что обратить внимание",
        "body": "Ключевые вопросы: есть ли минимальный депозит или гарантированная сумма? Можно ли принести свой торт? Включена ли музыка или ведущий? Есть ли технический райдер (проектор, микрофон, экран)? В «Парусах на крыше» (ул. Марата, 5) банкетный зал вмещает до 300 гостей, есть менеджер по мероприятиям, банкетное меню от 2 500 ₽/чел.",
        "highlight": "Скидка 20% на счёт именинника в «Парусах» действует 7 дней до и после дня рождения. Оплата наличными."
      },
      {
        "heading": "Как заранее забронировать",
        "body": "Для пятниц и суббот — бронируйте за 2–4 недели. Для декабря и праздничных дат — за 1–2 месяца. При бронировании уточните: депозит и условия отмены, формат подачи (банкет, фуршет, шведский стол), можно ли принести свои украшения. Позвоните +7 (812) 991-10-90 или читайте о <a href='/blog/banket-den-rozhdeniya-peterburg-ceny' class='underline text-accent'>ценах на банкет в день рождения</a>."
      }
    ],
    "cta": { "text": "Забронировать зал на день рождения", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "originalnyy-prazdnik-dr-restoran-spb",
    "title": "Оригинальный праздник на день рождения в ресторане СПб",
    "metaTitle": "Оригинальный праздник день рождения ресторан СПб 2026 | Паруса",
    "metaDescription": "Как организовать оригинальный и незабываемый день рождения в ресторане Петербурга: идеи, форматы, советы.",
    "keywords": "оригинальный день рождения ресторан спб, нестандартный день рождения петербург, необычный праздник спб",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/view_night.webp",
    "lead": "Стандартный день рождения в ресторане — это хорошо. Оригинальный — это когда гости рассказывают об этом вечере ещё через год. Разница не всегда в бюджете — часто в деталях, месте и формате.",
    "sections": [
      {
        "heading": "Что делает праздник оригинальным",
        "body": "Оригинальность — это неожиданное сочетание обычных вещей. Ужин на крыше с закатом вместо обычного зала. Живая музыка вместо фоновой playlist. Специально составленное меню вместо стандартного банкетного. Тематический декор в цветах именинника. Ни один из этих элементов не стоит запредельно — но вместе они создают неповторимое впечатление.",
        "list": [
          "Место с «вау-эффектом» — панорама, вид, нестандартный интерьер",
          "Живая музыка под конкретный вкус именинника",
          "Персонализированные детали: меню с именем, фото-зона",
          "Нестандартный формат подачи: мастер-класс, дегустация"
        ]
      },
      {
        "heading": "«Паруса» как место для нестандартного ДР",
        "body": "Ресторан «Паруса на крыше» (ул. Марата, 5, 6 этаж) — само по себе нестандартное место: 300° панорама Петербурга, открытая терраса летом, живая музыка. Для дня рождения можно организовать дегустацию вин, выступление приглашённого музыканта, тематический декор. Менеджер ресторана поможет с организацией. Скидка 20% для именинника.",
        "highlight": "Самый простой способ сделать ДР оригинальным — выбрать место, где гости ещё не бывали. Для большинства петербуржцев крыша Olympic Plaza — именно такое место."
      },
      {
        "heading": "Идеи для нестандартного формата",
        "body": "Ужин с живой музыкой под конкретный жанр (джаз, акустика, классика). Дегустационный сет из нескольких блюд с парингом вин — шеф подбирает пары. Мастер-класс по коктейлям или вину до ужина. Бранч в воскресенье вместо вечернего банкета — нестандартно и уютно. Подробнее о живой музыке — в нашей <a href='/blog/den-rozhdeniya-zhivaya-muzyka-restoran-peterburg' class='underline text-accent'>статье об ужинах с музыкой</a>."
      }
    ],
    "cta": { "text": "Спланировать оригинальный праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "luchshiy-restoran-dr-tsentr-spb",
    "title": "Лучший ресторан для дня рождения в центре СПб",
    "metaTitle": "Лучший ресторан для дня рождения центр СПб 2026 | Паруса на крыше",
    "metaDescription": "Лучший ресторан для дня рождения в центре Санкт-Петербурга: рейтинг, виды, цены, форматы праздника.",
    "keywords": "лучший ресторан день рождения центр спб, лучший ресторан день рождения петербург, ресторан др центральный район",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Найти лучший ресторан для дня рождения в центре Петербурга — задача непростая: вариантов много, а разница между «просто хорошим» и «лучшим» иногда не очевидна сразу. Разберём по критериям.",
    "sections": [
      {
        "heading": "Критерии «лучшего»",
        "body": "Каждый понимает «лучший» по-своему. Для одних — панорамный вид и «вау» при входе. Для других — идеальная кухня и тихий вечер. Для третьих — вместимость и возможность позвать 100 человек. Поэтому «лучший» всегда контекстуальный. Но есть рестораны, которые стабильно выигрывают по большинству критериев — и один из них в Петербурге — «Паруса на крыше».",
        "list": [
          "Вид и атмосфера: 6 этаж, 300° панорама, живая музыка",
          "Кухня: авторская, меню обновляется сезонно",
          "Вместимость: до 300 гостей для банкета",
          "Репутация: рейтинг 5,0, 2 606 отзывов, «Хорошее место 2026»"
        ]
      },
      {
        "heading": "Почему «Паруса» получают 5 звёзд стабильно",
        "body": "Поддерживать рейтинг 5,0 при 2 606 отзывах — это не случайность. Это означает, что каждый год сотни дней рождения проходят здесь и заканчиваются благодарными отзывами. Ресторан работает с 2009 года — значит, проверен временем. Скидка 20% для именинников (7 дней до и после дня рождения) делает выбор ещё очевиднее.",
        "highlight": "«Паруса на крыше» входят в топ ресторанов Петербурга для особых поводов по версии гостей — не маркетинговых рейтингов, а реальных людей с реальными оценками."
      },
      {
        "heading": "Практические детали",
        "body": "Адрес: ул. Марата, 5, Olympic Plaza, 6 этаж. Телефон: +7 (812) 991-10-90. Банкетное меню от 2 500 ₽/чел, средний чек 1 300 ₽. Бизнес-ланч от 590 ₽. Читайте о <a href='/blog/den-rozhdeniya-30-chelovek-restoran-spb' class='underline text-accent'>дне рождения на 30 человек</a> в нашем материале."
      }
    ],
    "cta": { "text": "Забронировать лучший стол на ДР", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "yubiley-zhenshchiny-restoran-peterburg",
    "title": "Где отметить юбилей женщины в ресторане Петербурга",
    "metaTitle": "Юбилей женщины ресторан Петербург 2026 | Паруса на крыше",
    "metaDescription": "Где отметить юбилей женщины в ресторане Санкт-Петербурга: идеи для 40, 50, 55 лет, форматы праздника.",
    "keywords": "юбилей женщины ресторан петербург, где отметить юбилей женщины спб, юбилей 50 лет женщина ресторан петербург",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 8,
    "image": "/photos/view_sunset.webp",
    "lead": "Юбилей женщины — особый повод, требующий особого внимания к деталям. 40, 50, 55, 60 лет — каждый возраст имеет свои ожидания от праздника. Расскажем, какой формат подойдёт лучше всего и где это организовать в Петербурге.",
    "sections": [
      {
        "heading": "Форматы юбилея по количеству гостей",
        "body": "Камерный ужин (8–15 человек): только близкие, уютная атмосфера, акцент на разговорах и общении. Выделенная зона ресторана (15–30 человек): больше простора для программы, живой музыки, тостов. Банкет (30–100 человек): полноценное мероприятие с ведущим, музыкантами, официальной частью.",
        "list": [
          "8–15 человек: камерный ужин, приятная атмосфера",
          "15–30: выделенная зона, возможна программа",
          "30–100: банкет с ведущим и музыкой",
          "100+: полное мероприятие с профессиональной организацией"
        ]
      },
      {
        "heading": "Почему место особенно важно для женского юбилея",
        "body": "Эстетика имеет значение. Панорамный ресторан с красивыми видами, элегантным интерьером и живой музыкой — это уже подарок, который виновница торжества получает при входе. «Паруса на крыше» (ул. Марата, 5, 6 этаж) — один из немногих ресторанов Петербурга, где сочетаются все элементы: вид на город, авторская кухня, возможность банкета до 300 гостей. Рейтинг 5,0.",
        "highlight": "Скидка 20% на счёт именинницы — в течение 7 дней до и после юбилея. Идеально для семейного ужина в честь особой даты."
      },
      {
        "heading": "Что сделать праздник незабываемым",
        "body": "Для юбилея женщины особенно важны детали: цветы на столе, персональное меню с именем, фото-слайдшоу, живая музыка в её вкусе. Заранее обсудите с менеджером ресторана: что можно принести, что организует ресторан, есть ли специальное меню для праздника. Читайте о <a href='/blog/gde-otmetit-50-let-yubilej-peterburg' class='underline text-accent'>юбилее 50 лет в Петербурге</a>."
      }
    ],
    "cta": { "text": "Забронировать юбилейный вечер", "href": "/banket" }
  },
  {
    "slug": "yubiley-muzhchiny-restoran-spb",
    "title": "Где отметить юбилей мужчины в ресторане СПб",
    "metaTitle": "Юбилей мужчины ресторан СПб 2026 | Паруса на крыше",
    "metaDescription": "Где отметить юбилей мужчины в ресторане Санкт-Петербурга: идеи для 40, 50, 60 лет, форматы и цены.",
    "keywords": "юбилей мужчины ресторан спб, где отметить юбилей мужчины петербург, юбилей 50 лет мужчина спб",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "Юбилей мужчины — это событие, которое нередко организуют другие: жена, дети, коллеги. Это значит, что ресторан выбирают «под него» — под его характер, привычки и вкусы. Расскажем, как это сделать правильно.",
    "sections": [
      {
        "heading": "Что важно мужчинам в праздновании",
        "body": "По опыту организаторов мероприятий, мужчины на юбилеях ценят: качество еды и напитков (особенно вин и крепкого алкоголя), отсутствие излишней «официальщины», хорошую компанию и возможность пообщаться, неожиданность места или формата. Банкет с вечным конферансье и скучной программой — не лучший выбор.",
        "list": [
          "Качество кухни важнее декора",
          "Живая музыка — да, если в нужном стиле (джаз, рок, классика)",
          "Неформальный формат для компании, которая хорошо знает друг друга",
          "Вид и атмосфера как разговорная тема на весь вечер"
        ]
      },
      {
        "heading": "«Паруса на крыше» для мужского юбилея",
        "body": "Мясо на хоспере, хорошие вина, вид на ночной Петербург с 6-го этажа — это понравится большинству мужчин независимо от возраста. Банкетный зал до 300 гостей, банкетное меню от 2 500 ₽/чел, скидка 20% виновнику торжества. Ресторан работает с 2009 года, рейтинг 5,0. Телефон: +7 (812) 991-10-90.",
        "highlight": "Живая музыка в «Парусах» — джаз и авторская музыка. Если виновник торжества любит конкретный стиль — можно обсудить с рестораном возможность приглашённого музыканта."
      },
      {
        "heading": "Советы по организации",
        "body": "Не переусердствуйте с программой: часто лучший юбилей — это хороший стол, хорошие люди и хорошее место. Заранее уточните у менеджера ресторана: есть ли возможность фотографа, что включено в банкетный пакет, каков порядок бронирования. Читайте о <a href='/blog/gde-otmetit-50-let-yubilej-peterburg' class='underline text-accent'>юбилее 50 лет в Петербурге</a>."
      }
    ],
    "cta": { "text": "Забронировать юбилей", "href": "/banket" }
  },
  {
    "slug": "syurpriz-restoran-den-rozhdeniya-spb",
    "title": "Как устроить сюрприз в ресторане на день рождения в СПб",
    "metaTitle": "Сюрприз в ресторане на день рождения СПб 2026 | Паруса на крыше",
    "metaDescription": "Как организовать сюрприз на день рождения в ресторане Петербурга: пошаговые советы и идеи.",
    "keywords": "сюрприз ресторан день рождения спб, как организовать сюрприз др петербург, сюрприз день рождения ресторан",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/view_night.webp",
    "lead": "Сюрприз-день рождения — один из самых трогательных форматов праздника. Но он требует координации с рестораном, точного тайминга и хорошей конспирации. Рассказываем, как это работает.",
    "sections": [
      {
        "heading": "Как это организовать",
        "body": "Шаг 1: выберите ресторан и забронируйте зал или стол — объясните менеджеру, что это сюрприз. Хороший ресторан войдёт в ситуацию. Шаг 2: придумайте легенду для именинника (почему и куда он идёт). Шаг 3: согласуйте с гостями точное время прихода — все должны быть на месте до именинника. Шаг 4: договоритесь о сигнале (звонок, SMS) когда объект близко.",
        "list": [
          "Заранее предупредите ресторан — это ключевое",
          "Придумайте убедительную легенду для именинника",
          "Гости должны прийти на 15–20 минут раньше",
          "Подумайте о первой реакции: фото, видео, поздравление"
        ]
      },
      {
        "heading": "Как ведут себя рестораны при сюрпризах",
        "body": "Опытные рестораны привыкли к таким запросам. В «Парусах на крыше» (ул. Марата, 5) это отработанная практика: менеджер помогает с координацией, персонал соблюдает конфиденциальность. Важно заранее обсудить: момент подачи торта (со свечами и «Happy Birthday»), можно ли принести свои украшения, поддержку с живой музыкой если нужна песня.",
        "highlight": "Лучший момент для сюрприза — когда именинник входит в зал и видит всех гостей разом. Это «вау-эффект» усиливается, если место само по себе красивое — вид с 6-го этажа работает вдвойне."
      },
      {
        "heading": "Чего избегать",
        "body": "Не организуйте сюрприз без предупреждения ресторана — возможны проблемы с рассадкой и меню. Не приглашайте слишком много гостей без заблаговременного бронирования зала. О том, можно ли принести торт в ресторан — читайте в нашем <a href='/blog/mozhno-li-priness-tort-v-restoran' class='underline text-accent'>FAQ</a>."
      }
    ],
    "cta": { "text": "Организовать сюрприз в «Парусах»", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "restoran-detskiy-prazdnik-peterburg",
    "title": "Ресторан для детского праздника в Петербурге",
    "metaTitle": "Ресторан для детского праздника Петербург 2026 | Паруса на крыше",
    "metaDescription": "Рестораны для детских праздников в Санкт-Петербурге: день рождения ребёнка, детское меню, игровые зоны.",
    "keywords": "ресторан детский праздник петербург, день рождения ребёнка ресторан спб, детский праздник ресторан петербург",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "День рождения ребёнка в ресторане — это особый формат, требующий сочетания детской программы и комфорта для взрослых. Найти правильный баланс не всегда просто.",
    "sections": [
      {
        "heading": "Что нужно для детского праздника в ресторане",
        "body": "Обязательный минимум: детское меню (не взрослые блюда в маленьких порциях), отдельное пространство или выделенная зона, возможность оформить зал шарами и украшениями, аниматор или развлекательная программа по желанию. Хороший бонус: игровая зона или прогулочная площадка рядом.",
        "list": [
          "Детское меню: паста, блинчики, курица, компот",
          "Выделенная зона — чтобы дети не мешали другим гостям",
          "Возможность украсить зал, принести торт",
          "Аниматор по запросу"
        ]
      },
      {
        "heading": "«Паруса на крыше» для семейного праздника",
        "body": "В «Парусах» есть детское меню, возможность организовать банкет в выделенном зале, торт можно принести с собой или заказать у ресторана. Для детского праздника ресторан подходит особенно для семей, где важно и удобство детей, и комфорт взрослых. Вид на Петербург с 6-го этажа — дополнительный аргумент: дети в восторге.",
        "highlight": "Для детских праздников лучше выбирать дневное время: 12:00–16:00. Дети бодры, взрослые расслаблены, и вид на дневной Петербург тоже прекрасен."
      },
      {
        "heading": "Что уточнить при бронировании",
        "body": "Есть ли детское меню, какова его стоимость. Можно ли пригласить аниматора. Есть ли место для игр. Можно ли принести торт со свечами. Условия оформления зала. Подробнее — в нашей статье о <a href='/blog/est-li-detskoe-menyu-v-parusakh' class='underline text-accent'>детском меню в «Парусах»</a>."
      }
    ],
    "cta": { "text": "Забронировать детский праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "korporativ-nedorogo-restoran-peterburg",
    "title": "Корпоратив недорого в ресторане Петербурга: как сэкономить",
    "metaTitle": "Корпоратив недорого ресторан Петербург 2026 | Паруса на крыше",
    "metaDescription": "Как организовать корпоратив недорого в ресторане Санкт-Петербурга: советы, форматы, оптимальный бюджет.",
    "keywords": "корпоратив недорого ресторан петербург, дешёвый корпоратив спб, корпоратив бюджетно петербург",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "«Недорогой корпоратив» — это не обязательно компромисс с качеством. Это грамотное распределение бюджета. Расскажем, как организовать корпоратив в ресторане, не переплачивая.",
    "sections": [
      {
        "heading": "Из чего складывается бюджет корпоратива",
        "body": "Основные статьи расходов: еда (банкетное меню или формат шведского стола), напитки (алкоголь — 30–40% от стоимости еды), аренда зала или минимальный чек, программа (ведущий, музыканты). Самая большая экономия — на формате программы и выборе времени (будни дешевле выходных).",
        "list": [
          "Еда: банкетное меню vs шведский стол (второй иногда дешевле)",
          "Напитки: приносить своё или заказывать по карте?",
          "Программа: ведущий + музыка vs «просто поужинать»",
          "Время: будние дни дешевле выходных на 10–20%"
        ]
      },
      {
        "heading": "Оптимальный бюджет на корпоратив",
        "body": "Реалистичный бюджет корпоратива в хорошем ресторане Петербурга — 3 000–4 500 ₽ на человека «под ключ» (еда + алкоголь + зал). На 40 человек это 120 000–180 000 ₽. «Паруса на крыше» (ул. Марата, 5): банкетное меню от 2 500 ₽/чел, алкоголь отдельно. Для бюджетного варианта — корпоративный обед в будни значительно дешевле.",
        "highlight": "Корпоративный бизнес-ланч в «Парусах» — от 590 ₽/чел. Хороший способ организовать командный обед в формате «небольшой корпоратив» в рабочее время."
      },
      {
        "heading": "Советы по экономии",
        "body": "Выбирайте будни. Откажитесь от ведущего — хорошая компания и музыкант в зале достаточно. Планируйте заранее: за 2–3 месяца до ноября-декабря цены ниже. Читайте о форматах на нашей <a href='/korporativ' class='underline text-accent'>странице корпоративов</a>."
      }
    ],
    "cta": { "text": "Рассчитать бюджет корпоратива", "href": "/korporativ" }
  },
  {
    "slug": "korporativ-yubiley-kompanii-peterburg",
    "title": "Корпоратив по случаю юбилея компании в Петербурге",
    "metaTitle": "Корпоратив юбилей компании Петербург 2026 | Паруса на крыше",
    "metaDescription": "Как организовать корпоратив на юбилей компании в Санкт-Петербурге: форматы, программа, ресторан.",
    "keywords": "корпоратив юбилей компании петербург, юбилей компании ресторан спб, праздник компании петербург",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 8,
    "image": "/photos/view_night.webp",
    "lead": "Юбилей компании — особое корпоративное событие. Это не просто ежегодный корпоратив, а официальное признание истории и команды. К такому мероприятию уровень требований выше — и к месту, и к программе.",
    "sections": [
      {
        "heading": "Чем юбилей компании отличается от обычного корпоратива",
        "body": "Юбилей — это нарратив. На обычном корпоративе команда отдыхает вместе. На юбилейном — отмечают путь, историю, достижения. Это значит: важна торжественность места, в программе должна быть официальная часть (речи, награждения, ретроспектива), гостям нужно пространство для сентиментальных моментов.",
        "list": [
          "Официальная часть: речь основателя, история компании, награждения",
          "Торжественность места: не просто «куда пойти поесть»",
          "Признание достижений: ретроспектива, фотохроника",
          "Корпоративная культура: мероприятие говорит о ценностях"
        ]
      },
      {
        "heading": "«Паруса на крыше» для юбилейного корпоратива",
        "body": "Ресторан «Паруса на крыше» (ул. Марата, 5, Olympic Plaza) — один из немногих в Петербурге, где можно провести корпоратив на 300 человек с профессиональной сценой, видом на город и гастрономическим уровнем выше среднего. Банкетное меню от 2 500 ₽/чел. Менеджер мероприятий — в подарок. Рейтинг 5,0.",
        "highlight": "Для юбилея 10, 15, 20 лет особенно важно сделать вечер «запоминающимся на следующие 10 лет». Место, которое само по себе впечатляет, — половина успеха."
      },
      {
        "heading": "Программа юбилейного вечера",
        "body": "Стандартная структура: фуршет-приём (30 минут), официальная часть (речи, награждения, 30–45 минут), торжественный ужин с программой (2–3 часа), неформальная часть с музыкой и общением. Читайте о <a href='/korporativ' class='underline text-accent'>корпоративных возможностях «Парусов»</a>."
      }
    ],
    "cta": { "text": "Забронировать юбилей компании", "href": "/korporativ" }
  },
  {
    "slug": "korporativnaya-vecherinka-tematika-spb",
    "title": "Корпоративная вечеринка с тематикой в Петербурге",
    "metaTitle": "Корпоративная вечеринка тематика СПб 2026 | Паруса на крыше",
    "metaDescription": "Как организовать тематическую корпоративную вечеринку в Санкт-Петербурге: идеи, форматы, ресторан.",
    "keywords": "корпоративная вечеринка тематика петербург, тематический корпоратив спб, корпоратив тема ресторан петербург",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "Тематическая корпоративная вечеринка — способ сделать событие запоминающимся. Гости приходят в образе, погружаются в атмосферу, а общая тема создаёт разговорный повод. Разберём популярные форматы.",
    "sections": [
      {
        "heading": "Популярные темы для корпоратива",
        "body": "Самые востребованные форматы: «Ретро» (70–80-е, джаз-эпоха), «Гэтсби» (20-е, арт-деко), «Черно-белый» (элегантный дресс-код), «Маскарад», «Морская тематика» (особенно актуально в Петербурге). Тема не должна быть обязательной — лучше когда она создаёт атмосферу, но никого не вынуждает.",
        "list": [
          "Ретро 70-80-х: джаз, живая музыка, соответствующий декор",
          "Гэтсби-вечеринка: золото, черное, перья — очень фотогенично",
          "Морская тема: в Петербурге особенно органично",
          "Black & White: элегантно, без лишних затрат на костюмы"
        ]
      },
      {
        "heading": "Как ресторан помогает с тематикой",
        "body": "«Паруса на крыше» (ул. Марата, 5) поддерживают тематические корпоративы: помогают с декором зала, координируют с ведущим и музыкантами, меню можно адаптировать под тему. Живая музыка — ключевой элемент большинства тематических вечеринок, в «Парусах» это организуется штатно.",
        "highlight": "«Морская тема» в «Парусах» — особенно органична: название ресторана, вид на город с высоты, паруса как метафора. Минимум усилий для создания атмосферы."
      },
      {
        "heading": "Практические советы",
        "body": "Не делайте тему слишком сложной: гости должны понять её за 5 секунд. Подготовьте реквизит — шляпы, маски, бокалы с брендингом. Согласуйте музыкальную программу под тему. Читайте о <a href='/korporativ' class='underline text-accent'>корпоративных мероприятиях в «Парусах»</a>."
      }
    ],
    "cta": { "text": "Организовать тематический корпоратив", "href": "/korporativ" }
  },
  {
    "slug": "chto-vkhodit-banketnyy-paket-korporativ",
    "title": "Что входит в банкетный пакет корпоратива в ресторане",
    "metaTitle": "Что входит в банкетный пакет корпоратива 2026 | Паруса на крыше",
    "metaDescription": "Что включает банкетный пакет для корпоратива в ресторане: еда, напитки, зал, услуги. Подробный разбор.",
    "keywords": "банкетный пакет корпоратив состав, что входит банкет корпоратив ресторан, банкетный пакет ресторан спб",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "«Банкетный пакет» — термин, за которым скрывается разный состав в разных ресторанах. Разберём, что обычно входит в пакет, что дополнительно и на что обращать внимание.",
    "sections": [
      {
        "heading": "Типичный состав банкетного пакета",
        "body": "Базовый банкетный пакет обычно включает: аренду зала (или минимальный гарантированный чек), банкетное меню (холодные закуски, горячие блюда, десерт), безалкогольные напитки (вода, соки), стандартное оформление (скатерти, посуда). Не включается: алкоголь (считается отдельно), программа (ведущий, музыканты), специальный декор, фотограф.",
        "list": [
          "Включено: зал, меню, безалкогольные напитки, базовый декор",
          "Не включено: алкоголь, программа, спецдекор, фотограф",
          "Минимальный чек: часто вместо аренды зала",
          "Услуги менеджера: в хороших ресторанах — бесплатно"
        ]
      },
      {
        "heading": "Банкетный пакет в «Парусах на крыше»",
        "body": "В «Парусах» (ул. Марата, 5) банкетное меню от 2 500 ₽/человек. В пакет входит: меню из нескольких перемен, безалкогольные напитки, обслуживание персоналом, координация менеджера мероприятий. Алкоголь рассчитывается отдельно по карте. Для зала до 300 гостей возможна полная аренда пространства.",
        "highlight": "Банкетное меню от 2 500 ₽/чел в «Парусах» — это несколько перемен блюд из авторской кухни. Для Петербурга и такого уровня заведения — конкурентная цена."
      },
      {
        "heading": "Как читать банкетное предложение",
        "body": "Всегда уточняйте: включён ли алкоголь, каков минимальный гарантированный чек, что происходит если гостей меньше заявленного. Читайте подробнее о банкете на нашей <a href='/banket' class='underline text-accent'>странице банкетных мероприятий</a>."
      }
    ],
    "cta": { "text": "Узнать о банкетных пакетах", "href": "/banket" }
  },
  {
    "slug": "korporativ-23-fevralya-restoran-spb",
    "title": "Корпоратив 23 февраля в ресторане СПб: идеи",
    "metaTitle": "Корпоратив 23 февраля ресторан СПб 2026 | Паруса на крыше",
    "metaDescription": "Как организовать корпоратив на 23 февраля в ресторане Санкт-Петербурга: форматы, программа, бронирование.",
    "keywords": "корпоратив 23 февраля ресторан спб, 23 февраля корпоратив петербург, ресторан 23 февраля спб",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "23 февраля — один из самых популярных поводов для корпоративного ужина. Особенно если в коллективе много мужчин. Расскажем, как организовать такое мероприятие с умом.",
    "sections": [
      {
        "heading": "Форматы корпоратива на 23 февраля",
        "body": "Обед или ужин командой: самый популярный формат, без излишней официальщины. Тематический вечер: военная тема, сабантуй, «мужской клуб». Деловой ужин с подведением итогов: совместить 23 февраля и стратегическую сессию. Для небольших команд (10–30 человек) достаточно выделенной зоны в ресторане.",
        "list": [
          "Ужин командой: самый востребованный формат",
          "Тематический вечер с программой под день",
          "Совместить с деловой повесткой — эффективно",
          "Маленькие команды (до 15 чел): приватная зона"
        ]
      },
      {
        "heading": "Бронирование на 23 февраля",
        "body": "Рестораны на 23 февраля бронируют за 2–4 недели. В «Парусах на крыше» (ул. Марата, 5) корпоративный ужин организуется на любое количество гостей. Банкетное меню от 2 500 ₽/чел, живая музыка по договорённости, зал до 300 гостей. Телефон: +7 (812) 991-10-90.",
        "highlight": "23 февраля — почти всегда рабочий день. Корпоративный ужин вечером — оптимальный формат. Бронируйте заранее: рестораны в центре СПб в этот день загружены."
      },
      {
        "heading": "Что добавить в программу",
        "body": "Идеи для 23 февраля: викторина на знание военной истории (можно в формате игры за столом), командные тосты, живая музыка в военно-патриотическом или джазовом стиле. Читайте о <a href='/korporativ' class='underline text-accent'>корпоративных возможностях ресторана</a>."
      }
    ],
    "cta": { "text": "Забронировать на 23 февраля", "href": "/korporativ" }
  },
  {
    "slug": "romantika-mesta-uzhin-peterburg",
    "title": "Романтические места для ужина в Петербурге: список",
    "metaTitle": "Романтические места для ужина Петербург 2026 | Паруса на крыше",
    "metaDescription": "Лучшие романтические места для ужина в Санкт-Петербурге: рестораны, виды, атмосфера. Топ 2026.",
    "keywords": "романтические места ужин петербург, романтический ужин место спб, куда пойти на романтический ужин петербург",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Петербург романтичен сам по себе — архитектура, белые ночи, каналы. Но найти правильное место для ужина «на двоих» с нужной атмосферой, хорошей кухней и незабываемым видом — задача, которая требует выбора. Делимся топом.",
    "sections": [
      {
        "heading": "Что создаёт романтическую атмосферу в ресторане",
        "body": "Исследования поведения показывают: романтическую атмосферу создают не просто свечи и цветы, а ощущение «только мы двое в особенном пространстве». Уединённость, особый вид, приятное освещение, негромкая живая музыка — всё это работает на нужный эффект. В Петербурге к этому добавляется архитектурный контекст.",
        "list": [
          "Уединённость: не общий зал, а столик у окна или в нише",
          "Особый вид: вода, купола, закат — Петербург во всей красе",
          "Освещение: тёплый свет, не яркие лампы",
          "Живая музыка: джаз или акустика — лучший выбор"
        ]
      },
      {
        "heading": "«Паруса на крыше» — романтическое место с видом",
        "body": "Панорама города с 6-го этажа в закатном свете — один из самых сильных романтических образов Петербурга. В «Парусах» (ул. Марата, 5) живая музыка по расписанию, тёплый интерьер, меню с блюдами для двоих. Рейтинг 5,0, работает с 2009 года. Скидка 20% именинникам.",
        "highlight": "Лучший столик — у панорамного окна с видом на запад. Попросите при бронировании за несколько дней. В пятницу вечером и субботу — самые романтические ужины."
      },
      {
        "heading": "Другие романтические форматы в Петербурге",
        "body": "Прогулка на кораблике по Неве → ужин. Экскурсия на крышу → ужин в «Парусах». Поход в театр (Мариинский или Михайловский) → ужин после спектакля. Каждый формат создаёт свою историю. Читайте о <a href='/romanticheskiy-uzhin' class='underline text-accent'>романтическом ужине</a> в нашем ресторане."
      }
    ],
    "cta": { "text": "Забронировать романтический ужин", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "restoran-privatnyy-stolik-peterburg",
    "title": "Ресторан с приватным столиком в Петербурге: где найти",
    "metaTitle": "Ресторан с приватным столиком Петербург 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с приватными столиками в Санкт-Петербурге: где поесть в уединении для пары или деловой встречи.",
    "keywords": "ресторан приватный столик петербург, ресторан для пары уединение спб, ресторан столик у окна петербург",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Приватный столик — это когда вы чувствуете, что в ресторане есть только вы. Полной изоляции в ресторанах обычно нет, но правильно расположенный столик у окна, в нише или на отдельной террасе создаёт нужное ощущение.",
    "sections": [
      {
        "heading": "Что такое «приватный столик»",
        "body": "Полноценная приватность — это отдельная комната или кабинет (бывает в крупных ресторанах, стоит дополнительно). Полуприватность — столик в нише, за ширмой, у стены. Условная приватность — «лучший столик у окна» вдали от основного зала. Для большинства пар и деловых встреч достаточно второго или третьего варианта.",
        "list": [
          "Отдельная комната: максимальная приватность, дополнительная стоимость",
          "Ниша или отдельная зона: хороший баланс уединения и атмосферы",
          "Столик у окна: ощущение «только мы и вид»",
          "Терраса: летом — особенно"
        ]
      },
      {
        "heading": "Как заказать приватный столик в «Парусах»",
        "body": "В «Парусах на крыше» (ул. Марата, 5) лучшие «приватные» столики — у панорамных окон с видом на Казанский собор. При бронировании по телефону +7 (812) 991-10-90 просите: «столик у окна с видом» или «столик в спокойной зоне». Менеджер подберёт оптимальное место под ваш повод.",
        "highlight": "Для предложения руки и сердца, важного разговора или деловой встречи — столик у окна с панорамой Петербурга создаёт нужный контекст."
      },
      {
        "heading": "Для деловых встреч",
        "body": "Приватность особенно важна для переговоров. «Паруса» предлагают приватные зоны для деловых обедов и ужинов. Читайте о <a href='/blog/delovoy-uzhin-restoran-peterburg' class='underline text-accent'>деловом ужине в ресторане</a>."
      }
    ],
    "cta": { "text": "Забронировать столик у окна", "href": "/" }
  },
  {
    "slug": "romanticheskiy-uzhin-vid-zakat-spb",
    "title": "Романтический ужин с видом на закат в Петербурге",
    "metaTitle": "Романтический ужин вид на закат СПб 2026 | Паруса на крыше",
    "metaDescription": "Где встретить закат за ужином в Санкт-Петербурге: лучшие рестораны с видом на закатное небо.",
    "keywords": "романтический ужин вид закат спб, ужин закат петербург ресторан, где встретить закат за ужином спб",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Закат в Петербурге — это природный спектакль. Небо над куполами соборов окрашивается в золото, оранжевый и розовый. Провести этот момент за хорошим столом — романтика в чистом виде.",
    "sections": [
      {
        "heading": "Когда закат в Петербурге",
        "body": "Летом в белые ночи (июнь–июль) солнце заходит за полночь — это магия, которую нельзя увидеть нигде южнее. Осенью и весной закат приходится на вечер — идеально для ужина 19:00–21:00. Зимой закат в 15:30–16:00 — деловой обед превращается в закатный ужин. Каждый сезон даёт своё ощущение.",
        "list": [
          "Июнь–июль: белые ночи, закат за полночь",
          "Август–сентябрь: золотой час в 20:00–21:00 — лучшее время",
          "Октябрь–ноябрь: закат в 17:00–18:00 — осенняя романтика",
          "Декабрь–январь: закат в 15:30 — необычный деловой ужин"
        ]
      },
      {
        "heading": "«Паруса» — ресторан с видом на западный закат",
        "body": "Западная ориентация панорамных окон «Парусов» (ул. Марата, 5, 6 этаж) означает: закатное солнце освещает зал золотым светом. Это создаёт особое освещение и визуальный эффект — даже профессиональный фотограф не смог бы сделать лучше. Живая музыка, авторская кухня, рейтинг 5,0.",
        "highlight": "Приходите на ужин за 45–60 минут до заката — вы успеете заказать блюда и выпить аперитив именно к тому моменту, когда небо начинает меняться."
      },
      {
        "heading": "Что заказать на закатный ужин",
        "body": "Лёгкие морепродукты или карпаччо как стартер. Бокал игристого или белого вина к закату. Горячее — мясо на хоспере или рыба. Десерт — после, когда город уже в ночных огнях. Читайте о <a href='/blog/romanticheskiy-uzhin-na-kryshe-peterburga' class='underline text-accent'>романтическом ужине на крыше Петербурга</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин на закате", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "restoran-krasivyy-vid-dvoe-peterburg",
    "title": "Ресторан с красивым видом для двоих в Петербурге",
    "metaTitle": "Ресторан с красивым видом для двоих Петербург 2026 | Паруса",
    "metaDescription": "Лучшие рестораны с красивым видом для пары в Санкт-Петербурге: куда пойти на свидание с видом.",
    "keywords": "ресторан красивый вид для двоих петербург, ресторан для пары с видом спб, красивый ресторан для двоих петербург",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Ресторан «для двоих» с красивым видом — один из самых сложных запросов. Нужно и уютно, и красиво, и вид чтобы «ахнуть», и кухня достойная. В Петербурге такие места есть — и их можно пересчитать по пальцам.",
    "sections": [
      {
        "heading": "Что значит «для двоих»",
        "body": "Ужин для двоих — не только романтическое свидание. Это может быть годовщина, день рождения любимого человека, важный разговор, встреча после долгой разлуки. В каждом случае важна атмосфера: уединение, красивый вид, хорошая еда, тихая музыка. Громкий шум и оживлённые соседние столики — враги ужина для двоих.",
        "list": [
          "Уединённость: столик в стороне от основного потока",
          "Вид: что-то красивое за окном, меняющееся с освещением",
          "Кухня: достаточно уровня, чтобы не отвлекала на себя",
          "Музыка: живая или тихая, не навязчивая"
        ]
      },
      {
        "heading": "«Паруса» для ужина на двоих",
        "body": "Столик у панорамного окна в «Парусах» (ул. Марата, 5, 6 этаж) — идеальный формат для двоих: вид на купола и крыши, тёплый свет, живая музыка в фоне. Средний чек на пару — около 2 600 ₽ (вместе). Бронируйте заранее и просите столик у окна. Рейтинг 5,0, работает с 2009 года.",
        "highlight": "Для предложения руки и сердца — отдельный сервис: предупредите менеджера заранее, они подготовят необходимое (цветы, шампанское, правильный момент)."
      },
      {
        "heading": "Когда лучше прийти",
        "body": "Пятница и суббота — самые атмосферные вечера: живая музыка, оживлённый зал создаёт фон, но не мешает разговору. Для деловой беседы или камерного настроения — будний вечер. Читайте об идеях для <a href='/blog/pervoe-svidanie-restoran-peterburg' class='underline text-accent'>первого свидания в ресторане</a>."
      }
    ],
    "cta": { "text": "Забронировать стол для двоих", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "kuda-pojti-s-lyubimym-peterburg",
    "title": "Куда пойти с любимым в Петербурге: идеи для пары",
    "metaTitle": "Куда пойти с любимым Петербург 2026 | Паруса на крыше",
    "metaDescription": "Куда пойти с любимым в Санкт-Петербурге: романтические идеи для пары — прогулки, рестораны, виды.",
    "keywords": "куда пойти с любимым петербург, идеи для пары петербург, романтика петербург куда пойти",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/view_clouds.webp",
    "lead": "Петербург — один из самых романтичных городов мира. Каналы, мосты, белые ночи, архитектурные виды — всё это создаёт идеальный фон для вечера с любимым человеком. Собрали лучшие идеи.",
    "sections": [
      {
        "heading": "Идеи для романтического вечера",
        "body": "Прогулка по набережным → ужин с видом. Речная прогулка на кораблике → коктейли в ресторане. Посещение музея или выставки → ужин в ресторане рядом. Разводные мосты ночью (июнь–сентябрь) → завтрак на рассвете. Каждый формат даёт свою историю и свои воспоминания.",
        "list": [
          "Набережная Невы → ужин в панорамном ресторане",
          "Кораблик по каналам → коктейли в «Парусах»",
          "Эрмитаж → ужин в ресторане рядом",
          "Разводные мосты → завтрак на рассвете"
        ]
      },
      {
        "heading": "Ужин в «Парусах» как кульминация вечера",
        "body": "После прогулки по городу — подъём на 6-й этаж Olympic Plaza (ул. Марата, 5). 300° панорама города, авторская кухня, живая музыка. Это то «вишенка на торте» которая превращает хороший вечер в незабываемый. Средний чек на двоих — 2 600 ₽. Рейтинг 5,0.",
        "highlight": "Комбинация «прогулка по центру + ужин в «Парусах» — классика петербургского романтического вечера. Маршрут: набережная Фонтанки → улица Марата → Olympic Plaza."
      },
      {
        "heading": "Для белых ночей",
        "body": "В период белых ночей особенно красиво: сначала прогулка до 23:00 при дневном свете, потом ужин в ресторане когда небо светлое, потом — к мостам на разводку. Читайте о <a href='/blog/peterburg-dlya-dvoyh-kuda-pojti' class='underline text-accent'>Петербурге для двоих</a>."
      }
    ],
    "cta": { "text": "Забронировать романтический вечер", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "luchshie-romanticheskie-restorany-spb",
    "title": "Лучшие романтические рестораны СПб: рейтинг 2026",
    "metaTitle": "Лучшие романтические рестораны СПб рейтинг 2026 | Паруса на крыше",
    "metaDescription": "Рейтинг лучших романтических ресторанов Санкт-Петербурга 2026: виды, атмосфера, кухня и цены.",
    "keywords": "лучшие романтические рестораны спб, романтический ресторан петербург рейтинг, топ романтических ресторанов спб",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 8,
    "image": "/photos/view_sunset.webp",
    "lead": "Рейтинг романтических ресторанов — субъективный жанр. Но есть объективные критерии: виды, атмосфера, качество кухни, отзывы гостей. Собрали ориентиры для тех, кто ищет лучшее место для особого вечера.",
    "sections": [
      {
        "heading": "Критерии романтического ресторана",
        "body": "Вид (особенно важно в Петербурге), освещение (тёплый, приглушённый свет), тихость (не дискотека в фоне), живая музыка или её качественная альтернатива, уровень кухни (хороший, но не обязательно мишленовский), возможность уединения (столик в стороне). Ни один ресторан не идеален по всем пунктам — но можно найти близкое.",
        "list": [
          "Вид: самый важный фактор в Петербурге",
          "Освещение: тёплый полумрак лучше яркого света",
          "Уровень шума: фоновый, не мешающий разговору",
          "Живая музыка: джаз и акустика — идеально"
        ]
      },
      {
        "heading": "«Паруса на крыше» в контексте рейтинга",
        "body": "По совокупности критериев «Паруса на крыше» (ул. Марата, 5, 6 этаж) — один из самых высокорейтинговых романтических ресторанов Петербурга. 2 606 отзывов и рейтинг 5,0 означают: большинство пар остались довольны. Работает с 2009 года — проверен временем.",
        "highlight": "Ресторан с рейтингом 5,0 и 2 606 отзывами — это не 20 отзывов от знакомых владельца. Это тысячи реальных вечеров, завершившихся благодарными оценками."
      },
      {
        "heading": "Что ещё стоит рассмотреть",
        "body": "Для самого камерного варианта — небольшие рестораны в исторических зданиях на Мойке или Фонтанке. Для панорамного — «Паруса». Для театрального — рестораны у Мариинского. Читайте о <a href='/romanticheskiy-uzhin' class='underline text-accent'>романтическом ужине</a> на нашем сайте."
      }
    ],
    "cta": { "text": "Забронировать романтический ужин", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "uzhin-nochnoy-vid-peterburg",
    "title": "Ужин с видом на ночной Петербург: лучшие места",
    "metaTitle": "Ужин с видом на ночной Петербург 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с видом на ночной Петербург: ужин при свете огней города, обзор лучших мест.",
    "keywords": "ужин вид ночной петербург, ресторан вид на ночной город спб, ужин ночью петербург вид",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/view_night.webp",
    "lead": "Ночной Петербург — это другой город. Подсветка соборов, огни набережных, мерцающие фонари и ночное небо — в тёмное время суток городская архитектура обретает новый характер. Ужин с этим видом — один из самых романтических форматов.",
    "sections": [
      {
        "heading": "Когда Петербург красивее — днём или ночью",
        "body": "Зависит от сезона. Летом белые ночи делают разницу незначительной — даже в полночь светло. Осенью и зимой ночная подсветка компенсирует короткий световой день. Декабрьский Петербург в огнях иллюминации — особенно красив. Осенью — строго, со свинцовым небом. Весной — с отражениями в мокром асфальте.",
        "list": [
          "Лето: белые ночи — почти нет разницы между днём и ночью",
          "Осень: ночная подсветка на фоне туманного неба — атмосферно",
          "Зима: иллюминация делает город сказочным",
          "Весна: отражения огней в лужах — петербургская эстетика"
        ]
      },
      {
        "heading": "«Паруса» ночью — другой опыт",
        "body": "Вечером и ночью в «Парусах» (ул. Марата, 5, 6 этаж) зал освещён тепло, а за окнами — ночной Петербург: подсвеченный купол Казанского собора, уличные огни, иногда — промельки фар разводных мостов. Это кинематографическая картинка. Рейтинг 5,0, живая музыка по пятницам и субботам.",
        "highlight": "В декабре и январе, когда за окном снег и огни иллюминации — «Паруса» особенно красивы. Петербургская зима + панорамный ресторан = визуальный праздник."
      },
      {
        "heading": "Практические детали",
        "body": "Ресторан работает до позднего вечера. Живая музыка — по расписанию (уточняйте на афише). Бронирование: +7 (812) 991-10-90 или онлайн. Читайте об <a href='/afisha' class='underline text-accent'>актуальной афише ресторана</a>."
      }
    ],
    "cta": { "text": "Забронировать ночной ужин с видом", "href": "/" }
  },
  {
    "slug": "restoran-para-zhivaya-muzyka-peterburg",
    "title": "Ресторан для пары с живой музыкой в Петербурге",
    "metaTitle": "Ресторан для пары живая музыка Петербург 2026 | Паруса на крыше",
    "metaDescription": "Лучшие рестораны для пары с живой музыкой в Санкт-Петербурге: романтический ужин под живые звуки.",
    "keywords": "ресторан пара живая музыка петербург, романтический ужин живая музыка спб, ресторан вдвоём музыка петербург",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Живая музыка на романтическом ужине — это то, что создаёт атмосферу даже без специальных декораций и программы. Правильный музыкант превращает обычный вечер в событие.",
    "sections": [
      {
        "heading": "Почему живая музыка важна",
        "body": "Фоновая музыка из динамиков создаёт фон. Живой музыкант создаёт атмосферу — живую, реагирующую, уникальную. Именно поэтому пары на особые поводы выбирают рестораны с живым звуком. Джазовый квартет, пианист, акустическая гитара — каждый формат создаёт своё настроение.",
        "list": [
          "Джаз: элегантно, нетривиально, создаёт интеллектуальный фон",
          "Пианист: классика романтического ужина",
          "Акустическая гитара: камерно, тепло, личное",
          "Вокал: зависит от исполнителя — может быть лучшим выбором"
        ]
      },
      {
        "heading": "Живая музыка в «Парусах на крыше»",
        "body": "«Паруса» (ул. Марата, 5) регулярно приглашают живых музыкантов — расписание публикуется в афише. Пятница, суббота, праздники — наиболее частое расписание. Джаз, авторская музыка, вокал — форматы разные. Сочетание: вид на Петербург с 6-го этажа + живой джаз + авторская кухня — это классика особого вечера.",
        "highlight": "Уточняйте расписание живой музыки при бронировании: +7 (812) 991-10-90. Или проверяйте на <a href='/afisha'>странице афиши</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин с живой музыкой", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "svadebnyy-uzhin-dvoe-restoran-spb",
    "title": "Свадебный ужин на двоих в ресторане СПб",
    "metaTitle": "Свадебный ужин на двоих ресторан СПб 2026 | Паруса на крыше",
    "metaDescription": "Свадебный ужин для двоих в ресторане Санкт-Петербурга: камерная свадьба без гостей, идеи и организация.",
    "keywords": "свадебный ужин двое ресторан спб, свадьба двое ресторан петербург, камерная свадьба ресторан спб",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Свадьба на двоих — тренд, который набирает популярность. Без гостей, без банкета, без официальной программы — только двое, лучший стол в лучшем ресторане города и ужин, который запомнится на всю жизнь.",
    "sections": [
      {
        "heading": "Почему свадьба на двоих — это часто лучший выбор",
        "body": "Большие свадьбы дорогие, сложные в организации и нередко оставляют молодожёнов с ощущением, что они вели себя как на работе — улыбались всем гостям, не успев обняться друг с другом. Свадьба на двоих — это день только для вас: выездная регистрация, фотосессия, ужин в лучшем ресторане. Всё внимание — друг другу.",
        "list": [
          "Дешевле большой свадьбы в разы",
          "Всё внимание — паре, не гостям",
          "Проще организовать: ресторан, фотограф, регистрация",
          "Более интимно и личное"
        ]
      },
      {
        "heading": "Свадебный ужин в «Парусах»",
        "body": "«Паруса на крыше» (ул. Марата, 5) — один из самых романтичных ресторанов Петербурга для такого формата. Лучший столик с видом на Казанский собор, авторское меню, шампанское, цветы по запросу — всё это организуется. Свадьба на двоих — звоните: +7 (812) 991-10-90. Рейтинг 5,0.",
        "highlight": "Шампанское, клубника, свечи, вид на Петербург с 6-го этажа — это может стать самым красивым вашим вечером. И не требует сотни гостей."
      },
      {
        "heading": "Как это организовать",
        "body": "Выездная регистрация → фотосессия на крышах центра → ужин в «Парусах». Или: регистрация → фотосессия → «Паруса». Простой план, результат — история на всю жизнь. Читайте о <a href='/svadba' class='underline text-accent'>свадебных возможностях ресторана</a>."
      }
    ],
    "cta": { "text": "Забронировать свадебный ужин", "href": "/svadba" }
  },
  {
    "slug": "torzhestvo-zhivaya-muzyka-restoran-spb",
    "title": "Торжество с живой музыкой в ресторане СПб",
    "metaTitle": "Торжество с живой музыкой ресторан СПб 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с живой музыкой для торжеств в Санкт-Петербурге: банкет, корпоратив, день рождения с живым звуком.",
    "keywords": "торжество живая музыка ресторан спб, банкет живая музыка петербург, мероприятие живая музыка ресторан",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Живая музыка превращает торжество из «хорошего ужина» в «незабываемый вечер». Правильно подобранный музыкант или ансамбль создаёт атмосферу, которую невозможно воссоздать с помощью плейлиста.",
    "sections": [
      {
        "heading": "Форматы живой музыки для торжеств",
        "body": "Фоновая живая музыка (соло пианист или гитарист): идеально для деловых ужинов и камерных торжеств. Джазовый дуэт или трио: атмосферно, универсально, не мешает разговорам. Вокалист с аккомпаниатором: популярно для дней рождения и юбилеев. Кавер-группа или оркестр: для больших банкетов с танцевальной частью.",
        "list": [
          "Соло инструмент: фон, не мешает разговорам",
          "Джазовый ансамбль: атмосфера и музыкальный уровень",
          "Вокалист: личное, трогает эмоционально",
          "Группа: для танцевальных вечеров 50+ человек"
        ]
      },
      {
        "heading": "Живая музыка в «Парусах на крыше»",
        "body": "«Паруса» (ул. Марата, 5) регулярно работают с живыми музыкантами — это часть концепции ресторана с 2009 года. Для банкетных мероприятий возможно пригласить конкретного музыканта или ансамбль. Уточняйте при бронировании. Читайте <a href='/afisha' class='underline text-accent'>актуальную афишу</a>."
      }
    ],
    "cta": { "text": "Забронировать торжество с музыкой", "href": "/banket" }
  },
  {
    "slug": "devichnik-idei-gde-provesti-spb",
    "title": "Девичник: идеи и где провести в СПб",
    "metaTitle": "Девичник идеи где провести СПб 2026 | Паруса на крыше",
    "metaDescription": "Идеи для девичника в Санкт-Петербурге: где провести, форматы, что включить в программу.",
    "keywords": "девичник идеи где провести спб, девичник петербург варианты, идеи девичник санкт-петербург",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Девичник — это последний вечер «в статусе невесты». Он должен быть особенным, но не обязательно безумным. Разберём самые популярные форматы в Петербурге и как выбрать подходящий.",
    "sections": [
      {
        "heading": "Форматы девичника",
        "body": "Спа + ужин: расслабленный, подходит для тех, кто ценит уют. Дегустация вин в ресторане: стильно, интересно, с обучающим элементом. Мастер-класс (коктейли, живопись) + ужин: активно и весело. Ужин в панорамном ресторане + вечерняя прогулка: для тех, кто любит красивый Петербург.",
        "list": [
          "Спа + ужин: расслабленно и уютно",
          "Дегустация вин: стильно, для ценительниц",
          "Мастер-класс + ужин: активно, весело",
          "Панорамный ужин + прогулка: красота Петербурга как главный подарок"
        ]
      },
      {
        "heading": "Девичник в «Парусах на крыше»",
        "body": "«Паруса» (ул. Марата, 5) — популярное место для девичников: красиво, вкусно, возможна дегустация вин, приватная зона для компании 8–20 человек. Живая музыка по расписанию, вид на город с 6-го этажа. Скидка 20% виновнице торжества. Рейтинг 5,0.",
        "highlight": "Организуйте дегустацию вин как часть программы девичника: сомелье или официант проведёт мини-гид по винной карте. Это вовлекает всех гостей."
      },
      {
        "heading": "Как спланировать",
        "body": "Определите формат под невесту, а не под подруг. Уточните количество гостей (6–15 человек — оптимально). Забронируйте ресторан за 1–2 недели. Читайте подробнее о <a href='/blog/devichnik-na-kryshe-peterburg' class='underline text-accent'>девичнике на крыше в Петербурге</a>."
      }
    ],
    "cta": { "text": "Забронировать девичник", "href": "/banket" }
  },
  {
    "slug": "malchishnik-krysha-peterburg",
    "title": "Мальчишник на крыше в Петербурге: идеи",
    "metaTitle": "Мальчишник на крыше Петербург 2026 | Паруса на крыше",
    "metaDescription": "Мальчишник на крыше в Санкт-Петербурге: форматы, идеи программы, лучшие рестораны.",
    "keywords": "мальчишник на крыше петербург, мальчишник ресторан крыша спб, мальчишник крыша петербург",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Мальчишник на крыше Петербурга — нестандартный, запоминающийся формат. Вид на ночной город, хорошие напитки, живая музыка — правильная атмосфера без лишних сложностей.",
    "sections": [
      {
        "heading": "Почему крыша — хороший выбор для мальчишника",
        "body": "Мальчишник должен быть «нестандартным» — это сигнал уважения к жениху. Крыша с видом на Петербург — это место, куда ходят не каждую пятницу. «Паруса на крыше» (ул. Марата, 5, 6 этаж) дают правильный «вау-эффект»: живая музыка, мясо на хоспере, хорошая винная карта, вид на ночной город. Для компании 8–20 человек — идеально.",
        "list": [
          "Нестандартное место — главное требование к мальчишнику",
          "Хорошая кухня и напитки важнее декора",
          "Живая музыка создаёт нужную атмосферу",
          "Вид на ночной Петербург — разговорная тема на весь вечер"
        ]
      },
      {
        "heading": "Программа мальчишника в «Парусах»",
        "body": "Встреча за коктейлями, мясо на хоспере как центральное блюдо, хорошие вина или виски, живая музыка (уточняйте расписание), осмотр ночного города с 6-го этажа. Всё это в рабочем режиме без специальной организации — просто выберите правильный стол. Средний чек 1 300–1 500 ₽/чел."
      },
      {
        "heading": "Полезные детали",
        "body": "Для мальчишника на 10–20 человек — бронируйте заранее, просите выделенную зону. Живая музыка: пятница и суббота. Читайте о <a href='/blog/malchishnik-restoran-spb' class='underline text-accent'>мальчишнике в ресторане СПб</a>."
      }
    ],
    "cta": { "text": "Забронировать мальчишник", "href": "/banket" }
  },
  {
    "slug": "malchishnik-nedorogo-spb",
    "title": "Мальчишник недорого в СПб: как организовать",
    "metaTitle": "Мальчишник недорого СПб 2026 | Паруса на крыше",
    "metaDescription": "Как организовать мальчишник недорого в Санкт-Петербурге: бюджетные варианты и советы.",
    "keywords": "мальчишник недорого спб, дешёвый мальчишник петербург, мальчишник бюджет спб",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Мальчишник не обязательно должен стоить целое состояние. Правильный выбор формата, времени и места позволяет организовать достойный вечер за разумный бюджет.",
    "sections": [
      {
        "heading": "Как снизить бюджет мальчишника",
        "body": "Выбирайте будний день — цены дешевле на 10–20%. Делайте акцент на еде, не на дополнительных активностях. Рассчитывайте алкоголь заранее — не «на всякий случай» больше. Небольшая компания 8–12 человек обойдётся значительно дешевле, чем 20+.",
        "list": [
          "Будни vs выходные: экономия 10–20%",
          "Небольшая компания: 8–12 человек оптимально",
          "Акцент на еде, а не на программе",
          "Алкоголь по карте, не «паушально»"
        ]
      },
      {
        "heading": "Бизнес-ланч как формат дневного мальчишника",
        "body": "Неожиданный вариант: дневной мальчишник в формате бизнес-ланча. В «Парусах» (ул. Марата, 5) бизнес-ланч от 590 ₽ — полноценный обед с видом на Петербург с 6-го этажа. Компания из 8–10 человек, хороший обед, виды — и всё в рамках разумного бюджета. Вечером — можно продолжить в другом формате.",
        "highlight": "Дневной мальчишник с 12:00 до 15:00 за бизнес-ланч — нестандартный и экономный формат. Подходит тем, кто хочет место, а не программу."
      }
    ],
    "cta": { "text": "Забронировать", "href": "/banket" }
  },
  {
    "slug": "delovoy-uzhin-restoran-peterburg",
    "title": "Деловой ужин в ресторане Петербурга: как выбрать место",
    "metaTitle": "Деловой ужин ресторан Петербург 2026 | Паруса на крыше",
    "metaDescription": "Как выбрать ресторан для делового ужина в Санкт-Петербурге: критерии, форматы, лучшие места.",
    "keywords": "деловой ужин ресторан петербург, бизнес ужин спб ресторан, ужин с партнёрами ресторан петербург",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "Деловой ужин — это не просто еда. Это переговоры в расслабленной обстановке, создание доверия, установление отношений. Выбор ресторана — часть сообщения, которое вы посылаете партнёру.",
    "sections": [
      {
        "heading": "Что важно для делового ужина",
        "body": "Уровень ресторана должен соответствовать статусу встречи — не слишком дешево (сигнал «вы для меня не важны») и не чрезмерно пафосно (выглядит неуместно). Важна тихость: деловой разговор требует слышать друг друга. Приватность: столик в стороне, не в центре зала. Высокое качество кухни — демонстрация вкуса.",
        "list": [
          "Уровень соответствует статусу встречи",
          "Тихость: разговор должен быть слышен",
          "Приватность: столик в стороне",
          "Качество кухни: демонстрация вкуса хозяина"
        ]
      },
      {
        "heading": "«Паруса» для делового ужина",
        "body": "«Паруса на крыше» (ул. Марата, 5, 6 этаж) — достаточно высокий уровень для важных переговоров, но без чрезмерного пафоса. Вид на город создаёт хороший «разговорный старт» — несколько минут все смотрят в окно. Приватные зоны по запросу. Рейтинг 5,0. Средний чек 1 300 ₽/чел. Телефон: +7 (812) 991-10-90.",
        "highlight": "Совет: приходите на 5–10 минут раньше партнёра — сядьте спиной к виду, чтобы партнёр видел панораму. Первое впечатление будет работать на вас."
      },
      {
        "heading": "Практические советы",
        "body": "Забронируйте столик в стороне от основного зала. Предупредите официанта, что это деловая встреча — обычно это означает менее навязчивое обслуживание. Читайте о <a href='/blog/delovoy-obed-spb-rестораны' class='underline text-accent'>деловом обеде в ресторанах СПб</a>."
      }
    ],
    "cta": { "text": "Забронировать деловой ужин", "href": "/" }
  },
  {
    "slug": "vypusknoy-krysha-spb",
    "title": "Выпускной вечер на крыше в СПб: идеи и рестораны",
    "metaTitle": "Выпускной на крыше СПб 2026 | Паруса на крыше",
    "metaDescription": "Выпускной вечер на крыше в Санкт-Петербурге: нестандартный формат для незабываемого окончания школы.",
    "keywords": "выпускной на крыше спб, выпускной крыша петербург, выпускной нестандартный место спб",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/view_summer.webp",
    "lead": "Выпускной в июне — одно из самых красивых событий петербургского календаря. Белые ночи, вся жизнь впереди, одноклассники рядом. Место должно соответствовать моменту.",
    "sections": [
      {
        "heading": "Почему выпускной на крыше — это правильно",
        "body": "Выпускной — символическое событие. Вы заканчиваете одну главу и начинаете другую. Высота, вид на город с крыши, белые ночи в июне — это метафора нового начала. Стандартный банкет в стандартном зале не передаёт этого масштаба. Крыша — передаёт.",
        "list": [
          "Июнь — белые ночи, самое красивое время года",
          "Высота создаёт ощущение «мир у ног»",
          "Нестандартное место — достойная точка перехода",
          "Виды на Петербург — лучшее фото выпускного альбома"
        ]
      },
      {
        "heading": "«Паруса» для выпускного класса",
        "body": "«Паруса на крыше» (ул. Марата, 5, 6 этаж) работают с группами для выпускных вечеров. Зал до 300 гостей, банкетное меню от 2 500 ₽/чел, живая музыка, открытая терраса летом. Все элементы для незабываемого вечера — в одном месте. Телефон: +7 (812) 991-10-90.",
        "highlight": "Выпускной в белые ночи — особенный: рассвет в 3:00 утра, город не спит. Заканчивайте банкет ближе к разводу мостов — это продолжение праздника."
      },
      {
        "heading": "Что включить в программу",
        "body": "Фуршет при входе с видом на закатный Петербург. Торжественная часть (слово от учителей/родителей). Ужин с живой музыкой. После ужина — прогулка к разводным мостам. Читайте о <a href='/blog/vypusknoy-restoran-spb' class='underline text-accent'>выпускном в ресторане СПб</a>."
      }
    ],
    "cta": { "text": "Забронировать выпускной", "href": "/banket" }
  }
];
